import React from 'react';
import { Flex, Text } from 'rebass';
import { Typography } from '@lomadee/design-system';
import {
  TextGreeting,
  CardDropdownContainer,
  TextAffliateOrganization,
  TextFinishOnboarding,
  OrganizationCard,
} from './styles';
import { useTranslation } from 'react-i18next';
import { MARY_KAY_WHITELABEL, OLIST_HOST_NAME } from '@plug/config/consts';
import { useCreateAccountContext } from '@plug/contexts/CreateAccountContext';
import { WhiteLabelStore } from '@plug/redux/store';
import { Avatar } from '@monitfy/ds';
import getCustomizatedColor from '@plug/helpers/get-customizated-color';
import { getContrastingColor } from '@plug/helpers/get-contrasting-color';

interface Props {
  organizationName?: string;
}

const AffiliateLeftContainer: React.FC<Props> = ({ organizationName }): JSX.Element => {
  const { t } = useTranslation();
  const { role } = useCreateAccountContext();
  const { isWhiteLabel, logo } = WhiteLabelStore.useState(s => s);
  const isOlist = OLIST_HOST_NAME.includes(window.location.hostname);
  const isMaryKay = MARY_KAY_WHITELABEL.includes(window.location.hostname);
  const onboardingColor = getCustomizatedColor('loginBackground', '#142159');
  const textOnboardingColor = getContrastingColor(onboardingColor);

  const hideCard = ['influencer.anapaulacarvalho.com', ...MARY_KAY_WHITELABEL].includes(
    window.location.hostname,
  );

  return (
    <>
      <TextGreeting>
        {isMaryKay && (
          <>
            <Text color={'#FFFFFF'} textAlign="center">
              {role === 'ADMIN' ? 'Olá, administrador!' : 'Olá, Consultora!'}
            </Text>

            <TextFinishOnboarding width="100%" style={{ color: textOnboardingColor }}>
              Você está a um clique de ter a sua loja online
            </TextFinishOnboarding>
          </>
        )}

        {isWhiteLabel && !isMaryKay && (
          <Text color={textOnboardingColor}>
            {role === 'ADMIN' ? 'Olá administrador!' : 'Olá parceiro!'}
          </Text>
        )}

        {!isWhiteLabel && (
          <Text color={'#F03460'}>{role === 'ADMIN' ? 'Olá administrador!' : 'Olá parceiro!'}</Text>
        )}
      </TextGreeting>

      {organizationName && !hideCard && (
        <Flex
          justifyContent="space-between"
          flexDirection="column"
          sx={{
            '@media screen and (max-width: 767px)': {
              justifyContent: 'flex-center',
            },
          }}
        >
          <TextAffliateOrganization style={{ color: textOnboardingColor }}>
            {isOlist
              ? 'Seja bem vindo à plataforma de parceria da Olist'
              : t('hubly-dashboard.signup.affiliate.left-side.organization-explain')}
          </TextAffliateOrganization>

          <CardDropdownContainer>
            <OrganizationCard>
              <Avatar
                size={'large'}
                persona="org"
                image={
                  logo ??
                  `https://plugone-production.nyc3.digitaloceanspaces.com/assets/favicons/${window.location.hostname}/favicon-32x32.png`
                }
                name={organizationName}
                transparent
              />

              <Typography size="16" lineHeight="20" color="neutralLowDark">
                {isOlist ? 'Programa de Afiliados Olist' : organizationName}
              </Typography>
            </OrganizationCard>
          </CardDropdownContainer>

          {/* {!isWhiteLabel && !isOlist && (
            <TextAffliateUnknownOrganization>
              {t('hubly-dashboard.signup.affiliate.left-side.organization-unrecognized.text')}{' '}
              <Link color={isEfizi ? '#FFDCD0' : '#DFE5FF'}>
                {t('hubly-dashboard.signup.affiliate.left-side.organization-unrecognized.anchor')}
              </Link>
            </TextAffliateUnknownOrganization>
          )} */}
        </Flex>
      )}

      <TextFinishOnboarding
        width="100%"
        textAlign="center"
        fontSize={isMaryKay ? '18px' : 'initial'}
        lineHeight={isMaryKay ? '20px' : 'initial'}
        style={{ color: textOnboardingColor }}
      >
        {isOlist && 'Complete seu cadastro e comece a transformar suas indicações em ganhos reais.'}

        {isMaryKay && (
          <div>
            Complete seu cadastro ao lado <br /> e tenha muito sucesso nas suas vendas.
          </div>
        )}

        {!isMaryKay && !isOlist && t('hubly-dashboard.signup.affiliate.left-side.description')}
      </TextFinishOnboarding>

      {isMaryKay && (
        <Flex flexDirection="column" style={{ gap: '16px' }}>
          <Typography color="neutralLow" fontWeight={400} size="22" textAlign="center" as="div">
            MARY KAY
          </Typography>

          <Typography color="neutralLow" fontWeight={400} size="28" textAlign="center" as="div">
            ♡
          </Typography>
        </Flex>
      )}
    </>
  );
};

export default AffiliateLeftContainer;
